import { Redirect } from 'react-router-dom';
import loadable from '@nordvpn/teams.core/lib/tools/loadable';
import { RouteGenerator } from 'routing/RouteGenerator';
import { USERS_ROLES_DETAILS_PATH, USERS_ROLES_LIST_PATH } from 'routing/routes/roles/constants';
import { USERS_LIST_PATH, USERS_MANAGEMENT_PATH, USER_DETAILS_PATH } from 'routing/routes/users/constants';
import { jsx as _jsx } from "react/jsx-runtime";
var UsersList = loadable(function () {
    return import(/* webpackPrefetch: true */ './pages/UsersList');
});
var UserDetails = loadable(function () {
    return import(/* webpackPrefetch: true */ './pages/UserDetails');
});
var RolesList = loadable(function () {
    return import(/* webpackPrefetch: true */ './pages/RolesList');
});
var RoleDetails = loadable(function () {
    return import(/* webpackPrefetch: true */ './pages/RoleDetails');
});
export var Routing = function Routing() {
    return RouteGenerator({
        usersManagementRoot: {
            path: USERS_MANAGEMENT_PATH,
            component: function component() {
                return /*#__PURE__*/ _jsx(Redirect, {
                    to: USERS_LIST_PATH
                });
            },
            exact: true
        },
        usersList: {
            path: USERS_LIST_PATH,
            component: UsersList,
            exact: true
        },
        userDetails: {
            path: USER_DETAILS_PATH,
            component: UserDetails,
            exact: true
        },
        rolesList: {
            path: USERS_ROLES_LIST_PATH,
            component: RolesList,
            exact: true
        },
        roleDetails: {
            path: USERS_ROLES_DETAILS_PATH,
            component: RoleDetails
        }
    });
};
